import { createContext, useCallback, useContext, useState } from 'react';

export type TableRow = Record<string, unknown> & {
  __originalValues?: Record<string, string>;
  __maskedValues?: Record<string, string>;
  __metaData?: unknown;
};

interface TableSelectionContextValue {
  clearSelection: () => void;
  selectedRows?: TableRow[];
  setSelectedRows: (rows?: TableRow[]) => void;
}

const TableSelectionContext = createContext<
  TableSelectionContextValue | undefined
>(undefined);

export const useTableSelection = (): TableSelectionContextValue => {
  const ctx = useContext(TableSelectionContext);
  if (!ctx) {
    throw new Error(
      'useTableSelection must be used within TableSelectionProvider'
    );
  }
  return ctx;
};

export const TableSelectionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [selectedRows, setSelectedRows] = useState<TableRow[]>();

  const clearSelection = useCallback(() => {
    setSelectedRows([]);
  }, []);

  const value = {
    selectedRows,
    setSelectedRows,
    clearSelection,
  };

  return (
    <TableSelectionContext.Provider value={value}>
      {children}
    </TableSelectionContext.Provider>
  );
};
